export function setModalTitle(modalMode: string | undefined,
    modalTitle: string): string {

    if (modalMode != undefined) {
        return modalMode + " " + modalTitle;
    }

    return modalTitle;
}